var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg009Crane = function Svg009Crane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.272 0H151v121H0v150h121v-60h30v271H61v30h300v-30h-90V211h120v60h-90v30h30v30h-30v30h211v-30h-30v-30h30v-30h-91v-60h91v-90H265.272zm-18.544 30 15 31H181V30zM181 91h35.728l15 30H181zm60 330h-60v-30h60zm0-60h-60v-30h60zm0-60h-60v-30h60zm-60 181v-31h60v31zm60-241h-60v-30h60zm241-60H30v-30h452z"
  })));
};
export default Svg009Crane;